import React, {useEffect, useState, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import AddFundsModal from './AddFundsModal';
import WithdrawModal from './WithdrawModal';
import SettingsModal from './SettingsModal';
import TradeChart from './TradeChart';

function shortenAddress(addr) {
  if (!addr || addr.length < 10) return addr || '';
  return addr.slice(0, 4) + '...' + addr.slice(-4);
}

function TradingPage({ solUsd, activeRpc, refreshRpc }) {
  const { walletName } = useParams();
  const navigate = useNavigate();
  const [walletData, setWalletData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [walletsList, setWalletsList] = useState([]);
  const [isAddOpen, setIsAddOpen] = useState(false);
  const [depositAddress, setDepositAddress] = useState('');
  const [solanaNetwork, setSolanaNetwork] = useState('mainnet-beta');
  const [isWithdrawOpen, setIsWithdrawOpen] = useState(false);
  const [isSettingsEditOpen, setIsSettingsEditOpen] = useState(false);
  const [trades, setTrades] = useState([]);
  const [stats, setStats] = useState([]);
  const [currentMint, setCurrentMint] = useState('');
  const [candles, setCandles] = useState([]);
  const [traderAddress, setTraderAddress] = useState('');
  const [walletsFull, setWalletsFull] = useState([]);
  const [coinRows, setCoinRows] = useState([]);
  const [traderSol, setTraderSol] = useState(null);
  const [mySol, setMySol] = useState(null);
  const lastTrade = Array.isArray(trades) && trades.length ? trades[trades.length - 1] : null;
  const [lastSymbol, setLastSymbol] = useState('');
  const pickLastMint = (arr) => (Array.isArray(arr) && arr.length ? arr[arr.length - 1]?.mint || '' : '');
  const [pairLabel, setPairLabel] = useState(''); 
  const [currentPriceUsd, setCurrentPriceUsd] = useState(null);
  const candlesRef = useRef([]);
  const prevLenRef = useRef(0);
  const lastTsRef = useRef(null);
  const [micro, setMicro] = useState([]);              // «живые» микро-свечи
  const microRef = useRef([]);
  const [streamActive, setStreamActive] = useState(false);
  const [rpcUpdatedAt, setRpcUpdatedAt] = useState(null);
  const [lastElapsedLive, setLastElapsedLive] = useState('');
  const [lastElapsedMeLive, setLastElapsedMeLive] = useState('');
  const [openTraderLive, setOpenTraderLive] = useState(null);
  const [buyAmountTraderLive, setBuyAmountTraderLive] = useState(null);
  const [buyAmountMeLive,  setBuyAmountMeLive]  = useState(null);
  const [perTokenTraderLive, setPerTokenTraderLive] = useState({ top:'', bottom:'' });
  const [perTokenMeLive, setPerTokenMeLive] = useState({ top:'', bottom:'' });
  const [openWalletLive, setOpenWalletLive] = useState({ top:'', bottom:'' });
  const [openMeLive, setOpenMeLive] = useState({ top:'', bottom:'' });
  const [avBuyMeLive, setAvBuyMeLive] = useState(null);
  const [avgTraderLive, setAvgTraderLive] = useState(null);
  const avgTraderRun = useRef({ usd: 0, sol: 0, n: 0 });
  const avgMeRun     = useRef({ usd: 0, sol: 0, n: 0 });
  const closedTraderRun = useRef({ usd: 0, sol: 0, n: 0 }); 
  const closedMeRun = useRef({ usd: 0, sol: 0, n: 0 }); 
  const [closedTraderLive, setClosedTraderLive] = useState(null); 
  const [closedMeLive, setClosedMeLive] = useState(null);
  const [pnlSrv, setPnlSrv] = useState({ trader: null, me: null });
  const [pnlTraderS, setPnlTraderS] = useState(null);
  const [pnlMeS, setPnlMeS] = useState(null);
  const [pendingExpanded, setPendingExpanded] = useState(false);
  const [pending, setPending] = useState([]);
  const [inputs, setInputs] = useState({});
  const [targets, setTargets] = useState({});
  const [priceInputs, setPriceInputs] = useState({});
  const [manualBuyOrders, setManualBuyOrders] = useState([]);
  const [manualBuyInputs, setManualBuyInputs] = useState({});
  const [, forceTick] = useState(0);
  const [currentPrices, setCurrentPrices] = useState({});
  const [tradesOpen, setTradesOpen] = useState(false);
  const [blacklist, setBlacklist] = useState([]);
  const clickSoundRef = useRef(new Audio('/click.mp3'));
  const [graphEnabled, setGraphEnabled] = useState(false)
  const reloadTradesRef = useRef(null); 


useEffect(() => {
  if (!walletName) {
    setStreamActive(false);
    return;
  }
  console.log("OPEN SSE for", walletName);
  const es = new EventSource(
    `/api-auth/trader-stream/${encodeURIComponent(walletName)}`,
    { withCredentials: true }
  );
  setStreamActive(true);
  es.onerror = () => {
    console.log("TRADER STREAM ERROR");
    setStreamActive(false);
  };
  es.onmessage = (ev) => {
    try {
      const trade = JSON.parse(ev.data);
      if (reloadTradesRef.current) {
        reloadTradesRef.current();
      }
    } catch {}
  };

  return () => {
    console.log("TRADER STREAM CLOSED");
    try { es.close(); } catch {}
    setStreamActive(false);
  };
}, [walletName]);


useEffect(() => { microRef.current = micro; }, [micro]);
  function upsert1s(arr, price, tsSec) {
  if (!Number.isFinite(price)) return arr;
  const bucket = Math.floor(tsSec / 1) * 1; // 1-секундная свеча
  const out = arr.length ? arr.slice() : [];
  let last = out[out.length - 1];

  if (!last || last.time !== bucket) {
    last = { time: bucket, open: price, high: price, low: price, close: price, volume: 0 };
    out.push(last);
  } else {
    last.high = Math.max(last.high, price);
    last.low  = Math.min(last.low,  price);
    last.close = price;
  }

  // держим последний 1 час «живой» ленты (3600 свечей по 1с)
  while (out.length > 3600) out.shift();
  return out;
}



  // Имя коина берём по текущему mint, а не из старых трейдов
useEffect(() => {
  if (!graphEnabled) return; 
  const mint = normalizeMint(currentMint);
  if (!mint) {
    setLastSymbol('');
    return;
  }

  fetch(`/api-auth/coininfo/${encodeURIComponent(mint)}`, { credentials: 'include' })
    .then(r => (r.ok ? r.json() : null))
    .then(j => setLastSymbol(j?.symbol || ''))
    .catch(() => setLastSymbol(''));
}, [graphEnabled, currentMint]);



  // Короткий символ для колонки Coin — держим в state и не очищаем на пустые ответы
const [coinText, setCoinText] = useState('');

useEffect(() => {
  if (!currentMint) {
    setCoinText('');
    return;
  }

  // если сервер дал нормальный символ — используем его
  if (lastSymbol) {
    setCoinText(lastSymbol);
    return;
  }

  // иначе показываем короткий адрес mint
  setCoinText(currentMint.slice(0, 4) + '...' + currentMint.slice(-4));
}, [currentMint, lastSymbol]);


function resetWalletState() {
  // базовые данные
  setCoinText('');
  setLastSymbol('');
  setPairLabel('');
  setCurrentMint('');
  // график
  setCandles([]);
  setMicro([]);
  setCurrentPriceUsd(null);
  // сделки
  setTrades([]);
  // балансы
  setTraderSol(null);
  setMySol(null);
  // pnl
  setPnlSrv({ trader: null, me: null });
  // live данные
  setBuyAmountTraderLive(null);
  setBuyAmountMeLive(null);
  setAvgTraderLive(null);
  setAvBuyMeLive(null);
  setClosedTraderLive(null);
  setClosedMeLive(null);
  // аккумуляторы
  avgTraderRun.current = { usd: 0, sol: 0, n: 0 };
  avgMeRun.current     = { usd: 0, sol: 0, n: 0 };
  closedTraderRun.current = { usd: 0, sol: 0, n: 0 };
  closedMeRun.current     = { usd: 0, sol: 0, n: 0 };
  // pending
  setPending([]);
  setInputs({});
  setTargets({});
  setPriceInputs({});

  setLoading(false);
}


useEffect(() => {
  resetWalletState();
}, [walletName]);


useEffect(() => {
  if (walletName) {
    localStorage.setItem('lastWallet', walletName);
  }
}, [walletName]);


useEffect(() => {
  if (!walletName) {
    const last = localStorage.getItem('lastWallet');
    if (last) {
      navigate(`/trading/${last}`, { replace: true });
    }
  }
}, [walletName, navigate]);


useEffect(() => {
  fetch('/api/wallets/settings-list')
    .then(r => r.json())
    .then(data => setWalletsList(data.map(w => w.walletName). filter(Boolean)))
    .catch(() => setWalletsList([]));
  }, [walletName]);


useEffect(() => {
  if (!walletName) { setTraderAddress(''); return; }
  (async () => {
    try {
      const r = await fetch(`/api-auth/api/wallet-full/${encodeURIComponent(walletName)}`, { credentials: 'include' });
      if (!r.ok) { setTraderAddress(''); return; }
      const w = await r.json();
      setTraderAddress(w?.settings?.traderAddress || '');
    } catch {
      setTraderAddress('');
    }
  })();
}, [walletName]);



    // Живое обновление Coin / Time elapsed / Open price без записи истории
useEffect(() => {
  if (!walletName) return;
  let stop = false;
  const tick = async () => {
    try {
      const r = await fetch(`/api-auth/trader-last/${encodeURIComponent(walletName)}`, {
        credentials: 'include',
      });
      const j = r.ok ? await r.json() : null;
      const tr = j?.trader;

      if (stop || !tr) return;

      // === TRADER LIVE ===

      // 1) Обновляем текущий mint по последней сделке трейдера
      const baseMint = tr.baseMint || tr.mint || (Array.isArray(tr.mints) ? tr.mints[0] : '');
      let nextMint = baseMint;

      // если это SOL или USDC, пробуем взять другой токен из списка mints
      if (nextMint === WSOL_MINT || nextMint === USDC_MINT) {
        if (Array.isArray(tr.mints)) {
          const alt = tr.mints.find((m) => m !== WSOL_MINT && m !== USDC_MINT);
          if (alt) nextMint = alt;
        }
      }

      if (nextMint) {
        setCurrentMint(nextMint);
      }

      // 2) Time elapsed (trader)
      const tms = Number(tr.time || tr.timestamp || 0);
      if (Number.isFinite(tms) && tms > 0) {
        const secs = Math.max(0, Math.floor((Date.now() - tms) / 1000));
        const mm = Math.floor(secs / 60);
        const ss = secs % 60;
        const human =
          mm < 60 ? (ss ? `${mm}m ${ss}s` : `${mm}m`) : `${Math.floor(mm / 60)}h ${mm % 60}m`;
        setLastElapsedLive(human);
      }

      // 3) Open price + price per token (TRADER)
      if (tr.priceQuotePerBase != null || tr.price != null) {
        const pricePerOne = Number(tr.priceQuotePerBase ?? tr.price); // цена за 1 токен
        const amount = Number(tr.baseAmount ?? tr.amount ?? 1); // сколько токенов куплено

        const fmt = formatOpenPriceForTrader(
          { priceQuotePerBase: pricePerOne, baseAmount: amount, quoteMint: tr.quoteMint },
          solUsd,
        );
        setOpenTraderLive(fmt);

        const per = formatPricePerToken(
          { priceQuotePerBase: pricePerOne, quoteMint: tr.quoteMint },
          solUsd,
        );
        setPerTokenTraderLive(per);
      }

      // 4) Buy amount (TRADER)
      const amt = Number(tr.baseAmount ?? tr.amount);
      if (Number.isFinite(amt)) {
        setBuyAmountTraderLive(amt);
      }

      // 5) AV Buy (TRADER)
      const avgTrader = updateAvBuyTraderLive(tr, solUsd, avgTraderRun.current);
      if (avgTrader && (avgTrader.top || avgTrader.bottom)) {
        setAvgTraderLive(avgTrader);
      }

      // 6) Closed Price (TRADER) — средняя СУММА всех SELL
      const closedTrader = updateClosedTraderLive(tr, solUsd, closedTraderRun.current);
      if (closedTrader && (closedTrader.top || closedTrader.bottom)) {
        setClosedTraderLive(closedTrader);
      }

      // === MY LIVE (без запросов; берём из state trades по текущему токену) ===
      const me = pickLastTradeBy(trades, 'me', nextMint || currentMint);

      if (me) {
        // 1) Time elapsed (ME)
        const tmsMe = Number(me.time || me.timestamp || 0);
        if (Number.isFinite(tmsMe) && tmsMe > 0) {
          const secs = Math.max(0, Math.floor((Date.now() - tmsMe) / 1000));
          const mm = Math.floor(secs / 60);
          const ss = secs % 60;
          const humanMe =
            mm < 60 ? (ss ? `${mm}m ${ss}s` : `${mm}m`) : `${Math.floor(mm / 60)}h ${mm % 60}m`;
          setLastElapsedMeLive(humanMe);
        } else {
          setLastElapsedMeLive('');
        }

        // 2) Open price (ME, сумма = цена за 1 * количество)
        if (me.priceQuotePerBase != null || me.price != null) {
          const pricePerOneMe = Number(me.priceQuotePerBase ?? me.price);
          const amountMe = Number(me.baseAmount ?? me.amount ?? 0);
          const fmtMe = formatOpenPriceForMe(
            {
              priceQuotePerBase: pricePerOneMe,
              baseAmount: amountMe,
              quoteMint: me.quoteMint,
              baseMint: me.baseMint,
            },
            solUsd,
          );
          setOpenWalletLive(fmtMe);
        } else {
          setOpenWalletLive(null);
        }

        // 3) Price per token (ME)
        if (me.priceQuotePerBase != null || me.price != null) {
          const perMe = formatPricePerToken(
            { priceQuotePerBase: Number(me.priceQuotePerBase ?? me.price), quoteMint: me.quoteMint },
            solUsd,
          );
          setPerTokenMeLive(perMe);
        } else {
          setPerTokenMeLive({ top: '', bottom: '' });
        }

        // 4) Buy amount (ME)
        const amtMe = Number(me.baseAmount ?? me.amount);
        setBuyAmountMeLive(Number.isFinite(amtMe) ? amtMe : null);

        // 5) AV Buy (ME)
        const avgMe = updateAvBuyMeLive(me, solUsd, avgMeRun.current);
        if (avgMe && (avgMe.top || avgMe.bottom)) {
          setAvBuyMeLive(avgMe);
        }
        // 6) Closed Price (ME) — средняя СУММА всех SELL
        const closedMe = updateClosedMeLive(me, solUsd, closedMeRun.current);
        if (closedMe && (closedMe.top || closedMe.bottom)) {
          setClosedMeLive(closedMe);
        }
        } else {
        // нет моей сделки по текущему токену → чистим
        setLastElapsedMeLive('');
        setOpenWalletLive(null);
        setPerTokenMeLive({ top: '', bottom: '' });
        setBuyAmountMeLive(null);
        setClosedMeLive(null);
      }
    } catch (e) {
      console.error(e);
    }

    // таймер: перезапускаем tick каждые 3 секунды, пока stop === false
    if (!stop) {
      setTimeout(tick, 3000);
    }
  };

  // первый запуск
  tick();

  // остановить обновления при размонтировании / смене кошелька
  return () => {
    stop = true;
  };
}, [walletName, solUsd, trades]);



useEffect(() => {
  if (!traderAddress) { setTraderSol(null); return; }
  (async () => {
    try {
      const r = await fetch(`/api-auth/api/trader-balance/${encodeURIComponent(traderAddress)}`, { credentials: 'include' });
      if (!r.ok) { setTraderSol(null); return; }
      const j = await r.json();
      setTraderSol(typeof j?.sol === 'number' ? j.sol : null);
    } catch {
      setTraderSol(null);
    }
  })();
}, [traderAddress]);



useEffect(() => {
  if (!walletName) { setMySol(null); return; }
  (async () => {
    try {
      const r = await fetch(`/api-auth/balance/${encodeURIComponent(walletName)}`, { credentials: 'include' });
      if (!r.ok) { setMySol(null); return; }
      const j = await r.json();
      setMySol(typeof j?.sol === 'number' ? j.sol : null);
    } catch {
      setMySol(null);
    }
  })();
}, [walletName]);




useEffect(() => {
  if (!walletName) { setTrades(null); return; }
  let stop = false;
  let timer = null;
  const load = async () => {
    try {
      const r = await fetch(`/api-auth/api/trades/${encodeURIComponent(walletName)}?limit=500`, { credentials: 'include' });
      if (!r.ok) {if (!stop) setTrades(null); return; }
      const j = await r.json();
      if (!stop) {
       const list = Array.isArray(j?.trades) ? j.trades : null;
       setTrades(list);
       console.log('TRADES len =', Array.isArray(list) ? list.length : 'NA');
       if (Array.isArray(list) && list.length) console.log('TRADES[0] =', list[0]);
       // обновляем мой live Buy amount по последней моей сделке в текущем токене
      const meLast = pickLastTradeBy(list, 'me', currentMint);
      const amtMe = meLast && typeof (meLast?.baseAmount ?? meLast?.amount) === 'number'
        ? Number(meLast.baseAmount ?? meLast.amount)
        : null;
      setBuyAmountMeLive(amtMe);
    }
    } catch {
      if (!stop) setTrades(null);
    }
  };
  reloadTradesRef.current = load;
  const start = (ms) => {
    if (timer) clearInterval(timer);
    timer = setInterval(load, ms);
  };
  load();
  const onVis = () => {
    if (document.visibilityState === 'visible') {
      load();
      start(3000);
    } else {
      start(15000);
    }
  };
  onVis();

  document.addEventListener('visibilitychange', onVis);
  window.addEventListener('focus', onVis);

  return () => {
     stop = true; 
     if (timer) clearInterval(timer);
     document.removeEventListener('visibilitychange', onVis);
     window.removeEventListener('focus', onVis);
  };
}, [walletName]);



useEffect(() => {
  if (!walletName || !currentMint) {
    setPnlSrv({ trader: null, me: null });
    return;
  }

  let stop = false;

  const load = async () => {
    try {
      const qs = new URLSearchParams({ mint: currentMint });
      if (Number.isFinite(currentPriceUsd)) qs.set('spotUsd', String(currentPriceUsd));
      const url = `/api-auth/api/pnl/${encodeURIComponent(walletName)}?` + qs.toString();

      const r = await fetch(url, { credentials: 'include' });
      const j = r.ok ? await r.json() : null;
      if (!stop) setPnlSrv({ trader: j?.trader || null, me: j?.me || null });
    } catch {
      if (!stop) setPnlSrv({ trader: null, me: null });
    }
  };

  load();
  const id = setInterval(load, 3000);
  return () => { stop = true; clearInterval(id); };
}, [walletName, currentMint, currentPriceUsd]);



useEffect(() => {
  if (!graphEnabled) return; 
  if (!currentMint) { setMicro([]); return; }
  const es = new EventSource(`/api-auth/price-stream/${encodeURIComponent(currentMint)}`, { withCredentials: true });
  es.onmessage = (e) => {
    let price = Number(e.data);
    if (!Number.isFinite(price)) {
      try { price = Number(JSON.parse(e.data)?.price); } catch {}
    }
    if (!Number.isFinite(price)) return;
    const nowSec = Math.floor(Date.now() / 1000);
    setCurrentPriceUsd(price);
    setMicro(prev => upsert1s(prev, price, nowSec));
  };

  es.onerror = () => { 
    try { es.close(); } catch {}
  };
  return () => { 
    try { es.close(); } catch {}
  }; 
}, [graphEnabled, currentMint]);


useEffect(() => {
  if (!graphEnabled) {
    setCandles([]);
    setMicro([]);
  }
}, [graphEnabled]);


  useEffect(() => { candlesRef.current = candles; }, [candles]);

  useEffect(() => {
    // при смене токена сразу очищаем старые свечи и микро-данные,чтобы график не показывал предыдущий coin
  setCandles([]);
  setMicro([]);
  setLastElapsedLive('');
  setOpenTraderLive(null);
  setPerTokenTraderLive({ top:'', bottom:'' });
  setBuyAmountTraderLive(null);
  setPerTokenMeLive({ top:'', bottom:'' });
  setOpenWalletLive(null);
  setBuyAmountMeLive(null);
  setAvgTraderLive({ top:'', bottom:'' });
  setAvBuyMeLive({ top:'', bottom:'' });
  avgTraderRun.current = { usd: 0, sol: 0, n: 0 };
  avgMeRun.current     = { usd: 0, sol: 0, n: 0 };
  setClosedTraderLive(null);
  setClosedMeLive(null);
  closedTraderRun.current = { usd: 0, sol: 0, n: 0 };
  closedMeRun.current     = { usd: 0, sol: 0, n: 0 };
  }, [currentMint]);

  const mergedCandles = React.useMemo(() => {
  // если истории нет — показываем только «живые» 1-сек свечи
  if (!Array.isArray(candles) || candles.length === 0) return micro;

  // отрезаем из истории всё, что совпадает по времени с микро-свечами,
  // чтобы не было дублей последней минуты
  const firstMicro = micro.length ? Number(micro[0].time) : Infinity;
  const hist = candles.filter(c => Number(c.time ?? c.timestamp) < firstMicro);

  // если истории совсем мало — не даём графику схлопнуться
  const base = hist.length >= 2 ? hist : candles.slice(-2);

  return micro.length ? [...base, ...micro] : base;
}, [candles, micro]);


  // История + реальный поток цен (SSE)
useEffect(() => {
  if (!graphEnabled) return; 
  const mint = normalizeMint(currentMint);
  if (!mint) return;

  let closed = false;

  (async () => {
    try {
      const tryFetch = async (tf, qs = '') => {
        const url = `/api-auth/candles/${encodeURIComponent(mint)}?tf=${tf}${qs}`;
        const r = await fetch(url, { credentials: 'include' });
        if (!r.ok) return null;
        const j = await r.json();
        const arr = Array.isArray(j?.candles) ? j.candles : [];
        return arr.length ? normalizeCandles(arr) : null;
      };

      const attempts = [
        () => tryFetch('1m',  '&all=1'),
        () => tryFetch('5m',  '&limit=500'),
        () => tryFetch('15m', '&limit=500'),
        () => tryFetch('1h',  '&limit=500'),
        () => tryFetch('4h',  '&limit=500'),
        () => tryFetch('1d',  '&limit=500'),
      ];

      let hist = null;
      for (const fn of attempts) {
        if (closed) return;
        hist = await fn();
        if (hist && hist.length) break;
      }
      if (!closed) setCandles(hist && hist.length ? hist : []);
    } catch {}
  })();

  return () => { closed = true; };
}, [graphEnabled, currentMint]);



useEffect(() => {
  const load = () =>
    fetch('/api/blacklist')
      .then(r => r.json())
      .then(d => setBlacklist(Array.isArray(d) ? d : []))
      .catch(() => {});

  load();
  const id = setInterval(load, 15000); // раз в 15 сек
  return () => clearInterval(id);
}, []);



useEffect(() => {
  if (!walletName) return;

  let stop = false;

  const loadPending = () => {
    fetch(`/api/pending/${walletName}`, {
      credentials: 'include'
    })
      .then(r => r.json())
      .then(data => {
        const list = Array.isArray(data) ? data : [];
        if (!stop) setPending(list);
      })
      .catch(() => {});
  };

  loadPending();
  const id = setInterval(loadPending, 3000);

  return () => {
    stop = true;
    clearInterval(id);
  };
}, [walletName]);



function formatAge(lastBuyTime) {
  if (!lastBuyTime) return '';
  const diff = Date.now() - Number(lastBuyTime);

  const h = Math.floor(diff / 3600000);
  return `${h}h`;
}


function sendTargetProfit(walletName, mint, pct, priceUsd) {
  return fetch(`/api/pending/target`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({
      walletName,
      mint,
      targetProfitPct: Number(pct),
      targetPriceUsd: String(priceUsd || '').trim() === '' ? null : Number(priceUsd)
    })
  });
}


function sendPendingSell(walletName, mint, amount) {
  return fetch(`/api/pending/sell`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({
      walletName,
      mint,
      amount
    })
  });
}


async function saveManualBuyOrder(walletName, rowIndex, mint, buyPriceUsd, buySumSol, targetProfitPct, targetPriceUsd, symbol, running) {
  let finalSymbol = symbol || '';
  if (!finalSymbol && mint) {
    try {
      const r = await fetch(`/api-auth/coininfo/${encodeURIComponent(mint)}`, {
        credentials: 'include'
      });
      const j = r.ok ? await r.json() : null;
      finalSymbol = j?.symbol || '';
    } catch {}
  }
  return fetch('/api-auth/api/manual-buy-order', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({
      walletName,
      rowIndex,
      mint,
      buyPriceUsd,
      buySumSol,
      targetProfitPct,
      targetPriceUsd,
      symbol: finalSymbol,
      running
    })
  });
}


function deleteManualBuyOrder(walletName, rowIndex) {
  return fetch('/api-auth/api/manual-buy-order/delete', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({
      walletName,
      rowIndex
    })
  });
}


async function loadManualBuyOrders(name = walletName) {
  if (!name) {
    setManualBuyOrders([]);
    return;
  }

  try {
    const r = await fetch(`/api-auth/api/manual-buy-order/${encodeURIComponent(name)}`, {
      credentials: 'include'
    });
    const j = r.ok ? await r.json() : [];
    setManualBuyOrders(Array.isArray(j) ? j : []);
  } catch {
    setManualBuyOrders([]);
  }
}

useEffect(() => {
  if (!walletName) {
    setManualBuyOrders([]);
    return;
  }

  let stop = false;

  const load = async () => {
    if (stop) return;
    await loadManualBuyOrders(walletName);
  };

  load();
  const id = setInterval(load, 3000);

  return () => {
    stop = true;
    clearInterval(id);
  };
}, [walletName]);



// НОРМАЛИЗАЦИЯ СВЕЧЕЙ: time -> секунды, числа -> Number, сортировка по времени
function normalizeCandles(list) {
  const arr = Array.isArray(list) ? list : [];
  const out = arr.map(c => {
    const t = Number(c.time);
    const sec = t > 1e11 ? Math.floor(t / 1000) : Math.floor(t); // если мс — делим на 1000
    return {
      time: sec,
      open: Number(c.open),
      high: Number(c.high),
      low:  Number(c.low),
      close:Number(c.close),
      volume: Number(c.volume ?? 0)
    };
  }).filter(c =>
    Number.isFinite(c.time) &&
    Number.isFinite(c.open) &&
    Number.isFinite(c.high) &&
    Number.isFinite(c.low) &&
    Number.isFinite(c.close)
  ).sort((a,b) => a.time - b.time);

  return out;
}


function getLastCoinFromTrades(tradesArr) {
  if (!Array.isArray(tradesArr) || tradesArr.length === 0) return { top:'', bottom:'' };

  // берём самую свежую сделку
  const t = tradesArr.slice().sort((a,b)=> (b.timestamp||b.time||0) - (a.timestamp||a.time||0))[0];

  // варианты полей из разных форматов
  const symbol =
    t.symbol || t.tokenSymbol || t.baseSymbol || t.pairSymbol || t.ticker || '';
  const base =
    t.base || t.baseToken || t.baseName || '';
  const quote =
    t.quote || t.quoteToken || t.quoteName || t.counterSymbol || '';
  const mint =
    t.mint || t.tokenAddress || t.baseMint || t.mintAddress || '';
  const pool =
    t.poolAddress || t.pairAddress || '';

  // верхняя строка — стараемся дать «символ»/пару
  let top = '';
  if (symbol && quote) top = `${symbol}/${quote}`;
  else if (symbol)     top = symbol;
  else if (base && quote) top = `${base}/${quote}`;

  // нижняя строка — идентификатор (mint/pool), если есть
  const id = mint || pool || '';
  const bottom = id ? (id.length > 10 ? (id.slice(0,4)+'...'+id.slice(-4)) : id) : '';

  return { top, bottom };
}



  // Берём последнюю сделку по указанному минту и "кто" это сделал
function pickLastTradeBy(tradesArr, who, mint) {
  const norm = (s) => normalizeMint(s || '');
  const curMint = norm(mint);
  if (!Array.isArray(tradesArr) || !tradesArr.length || !curMint) return null;

  return tradesArr
    .filter(t => {
      const tm = norm(
        t?.mint || t?.baseMint || t?.tokenAddress ||
        (Array.isArray(t?.mints) ? t.mints[0]
          : (t?.postTokenBalances?.[0]?.mint || t?.preTokenBalances?.[0]?.mint) || '')
      );
      if (tm !== curMint) return false;

      const isMine    = t.walletName === walletName;      // сделки вашего бота
      const isTrader  = t.walletName !== walletName;       // «чистые» сделки трейдера
      return who === 'me' ? isMine : isTrader;
    })
    .sort((a,b) => Number(b.timestamp||b.time||0) - Number(a.timestamp||a.time||0))[0] || null;
}

// Достаём цену в $ из трейда (priceQuotePerBase/price/priceUsd), и минт котировки
function toUsdPrice(t) {
  if (!t) return null;
  const p = (t.priceUsd != null) ? Number(t.priceUsd)
        : (t.priceQuotePerBase != null) ? Number(t.priceQuotePerBase)
        : (t.price != null) ? Number(t.price)
        : NaN;
  if (!Number.isFinite(p)) return null;
  return {
    priceQuotePerBase: p,
    quoteMint: t.quoteMint || null,
    baseAmount: t.baseAmount ?? t.amount ?? null,
    timestamp: Number(t.timestamp || t.time || 0),
    time: Number(t.time || t.timestamp || 0)
  };
}



function pickUniqueMints(tradesArr, limit = 20) {
  const seen = new Set(), out = [];
  (Array.isArray(tradesArr) ? tradesArr : [])
    .sort((a,b)=> (b.timestamp||b.time||0)-(a.timestamp||a.time||0))
    .forEach(t => {
      const m = t?.mint || t?.tokenAddress || t?.baseMint;
      if (m && !seen.has(m)) { seen.add(m); out.push(m); }
    });
  return out.slice(0, limit);
}



function normalizeMint(m) {
  if (!m) return '';
  const s = String(m).trim();
  const match = s.match(/[1-9A-HJ-NP-Za-km-z]{43,44}/);
  return match ? match[0] : s.slice(0, 44);
}



// ===== helpers для Coins =====
function lastTradeTimeByMint(tradesArr) {
  const map = new Map();
  (Array.isArray(tradesArr) ? tradesArr : []).forEach(t => {
    const mint = t.mint || t.tokenAddress || t.baseMint || t.mintAddress ||
  (Array.isArray(t.mints) ? t.mints[0] : '') ||
  (t.postTokenBalances?.[0]?.mint || t.preTokenBalances?.[0]?.mint) || '';
    const ts = t?.timestamp || t?.time || 0;
    if (mint && ts && (!map.has(mint) || map.get(mint) < ts)) {
      map.set(mint, ts);
    }
  });
  return map;
}



function formatElapsed(sec) {
  if (sec == null) return '';
  if (sec < 60) return `${Math.floor(sec)}s`;
  const m = Math.floor(sec / 60), s = Math.floor(sec % 60);
  if (m < 60) return s ? `${m}m ${s}s` : `${m}m`;
  const h = Math.floor(m / 60), m2 = m % 60;
  return m2 ? `${h}h ${m2}m` : `${h}h`;
}



 function getLastBasicTrade(tradesArr) {
  if (!Array.isArray(tradesArr) || tradesArr.length === 0) return null;
  return tradesArr.slice().sort((a,b)=>Number(b.timestamp||b.time||0)-Number(a.timestamp||a.time||0))[0];
}



const USDC_MINT = 'EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v';
const WSOL_MINT = 'So11111111111111111111111111111111111111112';



// ВРЕМЕННО: смотрим реальные данные трейда
useEffect(() => {
  if (Array.isArray(trades) && trades.length) {
    console.log("=== Пример трейда ===");
    console.log(JSON.stringify(trades[0], null, 2));
  } 
}, [trades]);


  // DEBUG: смотрим SELL по текущему токену (trader / me)
useEffect(() => {
  if (!Array.isArray(trades) || !trades.length || !currentMint) return;

  const norm    = (s) => normalizeMint(s || '');
  const curMint = norm(currentMint);

  const sellsTrader = trades.filter(t => {
    const tm = norm(
      t?.mint ||
      t?.baseMint ||
      t?.tokenAddress ||
      (Array.isArray(t?.mints) ? t.mints[0]
        : (t?.postTokenBalances?.[0]?.mint || t?.preTokenBalances?.[0]?.mint) || '')
    );
    if (tm !== curMint) return false;

    const side   = String(t?.side || t?.trader?.side).toLowerCase();
    const isMine = !!t?.me;
    return !isMine && side === 'sell';
  });

  const sellsMe = trades.filter(t => {
    const tm = norm(
      t?.mint ||
      t?.baseMint ||
      t?.tokenAddress ||
      (Array.isArray(t?.mints) ? t.mints[0]
        : (t?.postTokenBalances?.[0]?.mint || t?.preTokenBalances?.[0]?.mint) || '')
    );
    if (tm !== curMint) return false;

    const side = String(t?.me?.side || t?.side).toLowerCase();
    return !!t?.me && side === 'sell';
  });

  console.log('SELL DEBUG: trader sells =', sellsTrader.length, 'me sells =', sellsMe.length, 'mint =', curMint);
  if (sellsTrader[0]) {
    console.log('SELL DEBUG example trader =', JSON.stringify(sellsTrader[0], null, 2));
  }
  if (sellsMe[0]) {
    console.log('SELL DEBUG example me =', JSON.stringify(sellsMe[0], null, 2));
  }
}, [trades, currentMint]);


    // === Маркеры для графика: сделки трейдера в USD (OPEN/SELL) ===
const chartMarkers = React.useMemo(() => {
  if (!Array.isArray(trades) || trades.length === 0) return [];

  const norm = (s) => normalizeMint(s || '');
  const curMint = norm(currentMint);
  const mintOf = (t) => norm(
    t?.mint ||
    t?.baseMint ||
    t?.tokenAddress ||
    (Array.isArray(t?.mints) ? t.mints[0]
      : (t?.postTokenBalances?.[0]?.mint || t?.preTokenBalances?.[0]?.mint) || '')
  );

  return trades
    .filter(t => mintOf(t) === curMint)
    .map(t => {
      const tms = Number(t?.time ?? t?.timestamp ?? t?.blockTime ?? t?.block_timestamp ?? 0);
      const timeSec = tms > 1e12 ? Math.floor(tms / 1000) : Math.floor(tms);
      if (!Number.isFinite(timeSec)) return null;

      // ❗ Берём только поле priceUsd
      const priceUsd = Number(t?.priceUsd);
      if (!Number.isFinite(priceUsd)) return null;

      const sideStr = String(t?.side || t?.type || '').toLowerCase();
      const label =
        sideStr === 'buy'  ? 'OPEN' :
        sideStr === 'sell' ? 'CLOSE' : 'TRADE';

      return {
        id: `trade_${timeSec}_${priceUsd}_${sideStr || 'na'}`,
        time: timeSec,
        price: priceUsd,
        side: (sideStr === 'buy' || sideStr === 'sell') ? sideStr : null,
        who: 'TRADER',
        label
      };
    })
    .filter(Boolean)
    .sort((a, b) => a.time - b.time);
}, [trades, currentMint]);



useEffect(() => {
  try {
    console.log('chartMarkers len =', Array.isArray(chartMarkers) ? chartMarkers.length : 'NA');
    if (Array.isArray(chartMarkers) && chartMarkers.length) {
    }
  } catch (e) { /* ignore */ }
}, [chartMarkers]);



function getLastPricedTrade(tradesArr) {
  if (!Array.isArray(tradesArr)) return null;
  const mapped = tradesArr.map(t => {
    if (t?.priceQuotePerBase != null) return t;
    if (t?.price != null) {
      return {
        ...t,
        priceQuotePerBase: Number(t.price),
        quoteMint: t.quoteMint || USDC_MINT,
        timestamp: t.timestamp || t.time || 0,
        time: t.time || 0
      };
    }
    return null;
  }).filter(Boolean);
  if (!mapped.length) return null;
  return mapped.sort((a,b)=>(Number(b.timestamp||b.time||0)-Number(a.timestamp||a.time||0)))[0];
}


function formatPricePerToken(t, solUsd) {
  if (!t || t.priceQuotePerBase == null) return { top:'', bottom:'' };
  const p = Number(t.priceQuotePerBase);
  const q = t.quoteMint || '';
  const WSOL = 'So11111111111111111111111111111111111111112';
  const USDC = 'EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v';

  // если нет quoteMint — считаем как USDC (фолбэк)
  const qEff = (q === WSOL || q === USDC) ? q : USDC;

  let top = '', bottom = '';
  if (qEff === WSOL) {
    top = `${p.toFixed(4)} SOL`;
    if (typeof solUsd === 'number' && solUsd > 0) bottom = `$${(p * solUsd).toFixed(2)}`;
  } else {
    bottom = `$${p.toFixed(2)}`;
    if (typeof solUsd === 'number' && solUsd > 0) top = `${(p / solUsd).toFixed(4)} SOL`;
  }
  return { top, bottom };
}



function formatOpenPriceForTrader(t, solUsd) {
  if (!t) return { top: '', bottom: '' };

  const pricePerOne = Number(t.priceQuotePerBase ?? t.price ?? 0);
  const amount = Number(t.baseAmount ?? t.amount ?? 0);
  const quoteMint = t.quoteMint ?? '';
  const baseMint = t.baseMint ?? '';

  if (!pricePerOne || !amount) return { top: '', bottom: '' };

  // сумма сделки
  let totalSol = 0;
  let totalUsd = 0;

  // если цена указана в SOL
  if (quoteMint === 'So11111111111111111111111111111111111111112') {
    totalSol = pricePerOne * amount;
    totalUsd = solUsd ? totalSol * solUsd : 0;
  }
  // если цена указана в USDC
  else if (quoteMint === 'EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v') {
    totalUsd = pricePerOne * amount;
    totalSol = solUsd ? totalUsd / solUsd : 0;
  }
  // если нет данных о quoteMint — пробуем определить по baseMint
  else if (baseMint === 'So11111111111111111111111111111111111111112') {
    totalSol = amount;
    totalUsd = solUsd ? totalSol * solUsd : 0;
  }

  return {
    top: `${totalSol.toFixed(6)} SOL`,
    bottom: `$${totalUsd.toFixed(6)}`
  };
}



function formatOpenPriceForMe(t, solUsd) {
  if (!t) return { top: '', bottom: '' };

  const pricePerOne = Number(t.priceQuotePerBase ?? t.price ?? 0);
  const amount     = Number(t.baseAmount ?? t.amount ?? 0);
  const quoteMint  = t.quoteMint ?? '';
  const baseMint   = t.baseMint ?? '';

  if (!pricePerOne || !amount) return { top: '', bottom: '' };

  let totalSol = 0, totalUsd = 0;

  // цена в SOL
  if (quoteMint === 'So11111111111111111111111111111111111111112') {
    totalSol = pricePerOne * amount;
    totalUsd = solUsd ? totalSol * solUsd : 0;
  }
  // цена в USDC
  else if (quoteMint === 'EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v') {
    totalUsd = pricePerOne * amount;
    totalSol = solUsd ? totalUsd / solUsd : 0;
  }
  // fallback: если base — это WSOL
  else if (baseMint === 'So11111111111111111111111111111111111111112') {
    totalSol = amount;
    totalUsd = solUsd ? totalSol * solUsd : 0;
  }

  return {
    top:    `${totalSol.toFixed(6)} SOL`,
    bottom: `$${totalUsd.toFixed(6)}`
  };
}



  // === Av Buy price (LIVE) — ТРЕЙДЕР ===
function updateAvBuyTraderLive(trade, solUsd, acc /* {usd:0, sol:0, n:0} */) {
  if (!trade) return { top:'', bottom:'' };

  const WSOL = 'So11111111111111111111111111111111111111112';
  const USDC = 'EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v';

  const pricePerOne = Number(trade.priceQuotePerBase ?? trade.price ?? 0);
  const amount      = Number(trade.baseAmount ?? trade.amount ?? 0);
  const quoteMint   = trade.quoteMint ?? '';
  const baseMint    = trade.baseMint  ?? '';

  if (!pricePerOne || !amount) return { top:'', bottom:'' };

  let totalSol = 0, totalUsd = 0;
  if (quoteMint === WSOL) {
    totalSol = pricePerOne * amount;
    totalUsd = solUsd ? totalSol * solUsd : 0;
  } else if (quoteMint === USDC) {
    totalUsd = pricePerOne * amount;
    totalSol = solUsd ? totalUsd / solUsd : 0;
  } else if (baseMint === WSOL) {
    totalSol = amount;
    totalUsd = solUsd ? totalSol * solUsd : 0;
  }

  acc.usd += totalUsd;
  acc.sol += totalSol;
  acc.n   += 1;

  const avgSol = acc.sol / acc.n;
  const avgUsd = acc.usd / acc.n;

  return { top: `${avgSol.toFixed(6)} SOL`, bottom: `$${avgUsd.toFixed(6)}` };
}



  // === Av Buy price (LIVE) — МОЙ КОШЕЛЁК ===
function updateAvBuyMeLive(meTrade, solUsd, acc /* {usd:0, sol:0, n:0} */) {
  if (!meTrade) return { top:'', bottom:'' };

  const WSOL = 'So11111111111111111111111111111111111111112';
  const USDC = 'EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v';

  const pricePerOne = Number(meTrade.priceQuotePerBase ?? meTrade.price ?? 0);
  const amount      = Number(meTrade.baseAmount ?? meTrade.amount ?? 0);
  const quoteMint   = meTrade.quoteMint ?? '';
  const baseMint    = meTrade.baseMint  ?? '';

  if (!pricePerOne || !amount) return { top:'', bottom:'' };

  let totalSol = 0, totalUsd = 0;
  if (quoteMint === WSOL) {
    totalSol = pricePerOne * amount;
    totalUsd = solUsd ? totalSol * solUsd : 0;
  } else if (quoteMint === USDC) {
    totalUsd = pricePerOne * amount;
    totalSol = solUsd ? totalUsd / solUsd : 0;
  } else if (baseMint === WSOL) {
    totalSol = amount;
    totalUsd = solUsd ? totalSol * solUsd : 0;
  }

  acc.usd += totalUsd;
  acc.sol += totalSol;
  acc.n   += 1;

  const avgSol = acc.sol / acc.n;
  const avgUsd = acc.usd / acc.n;

  return { top: `${avgSol.toFixed(6)} SOL`, bottom: `$${avgUsd.toFixed(6)}` };
}



    // === Closed Price (avg SELL sum) — ТРЕЙДЕР ===
function updateClosedTraderLive(trade, solUsd, acc /* {usd:0, sol:0, n:0} */) {
  // если трейда нет и ещё не было ни одной продажи — пусто
  if (!trade && !acc.n) return { top: '', bottom: '' };

  const sideStr = String(trade?.side || trade?.type || '').toLowerCase();

  // если это не SELL — просто возвращаем уже накопленное среднее, ничего не меняем
  if (!trade || sideStr !== 'sell') {
    if (!acc.n) return { top: '', bottom: '' };
    const avgSol = acc.sol / acc.n;
    const avgUsd = acc.usd / acc.n;
    return {
      top:    `${avgSol.toFixed(6)} SOL`,
      bottom: `$${avgUsd.toFixed(6)}`
    };
  }

  const pricePerOne = Number(trade.priceQuotePerBase ?? trade.price ?? 0);
  const amount      = Number(trade.baseAmount ?? trade.amount ?? 0);
  const quoteMint   = trade.quoteMint ?? '';
  const baseMint    = trade.baseMint  ?? '';

  if (!pricePerOne || !amount) {
    if (!acc.n) return { top: '', bottom: '' };
    const avgSol = acc.sol / acc.n;
    const avgUsd = acc.usd / acc.n;
    return {
      top:    `${avgSol.toFixed(6)} SOL`,
      bottom: `$${avgUsd.toFixed(6)}`
    };
  }

  let tradeSol = 0;
  let tradeUsd = 0;

  if (quoteMint === WSOL_MINT) {
    tradeSol = pricePerOne * amount;
    tradeUsd = solUsd ? tradeSol * solUsd : 0;
  } else if (quoteMint === USDC_MINT) {
    tradeUsd = pricePerOne * amount;
    tradeSol = solUsd ? tradeUsd / solUsd : 0;
  } else if (baseMint === WSOL_MINT) {
    tradeSol = amount;
    tradeUsd = solUsd ? tradeSol * solUsd : 0;
  } else {
    // fallback: считаем как $, при наличии solUsd переводим в SOL
    tradeUsd = pricePerOne * amount;
    if (solUsd) tradeSol = tradeUsd / solUsd;
  }

  // накапливаем сумму SELL по аналогии с Av
  acc.usd = (acc.usd || 0) + tradeUsd;
  acc.sol = (acc.sol || 0) + tradeSol;
  acc.n   = (acc.n   || 0) + 1;

  const avgSol = acc.sol / acc.n;
  const avgUsd = acc.usd / acc.n;

  return {
    top:    `${avgSol.toFixed(6)} SOL`,
    bottom: `$${avgUsd.toFixed(6)}`
  };
}



    //  МОЙ КОШЕЛЁК  Closed Price (avg SELL sum) 

function updateClosedMeLive(meTrade, solUsd, acc /* {usd:0, sol:0, n:0} */) {
  // если трейда нет и ещё не было ни одной продажи — пусто
  if (!meTrade && !acc.n) return { top: '', bottom: '' };

  const sideStr = String(meTrade?.side || meTrade?.type || '').toLowerCase();

  // если это не SELL — просто возвращаем уже накопленное среднее, ничего не меняем
  if (!meTrade || sideStr !== 'sell') {
    if (!acc.n) return { top: '', bottom: '' };
    const avgSol = acc.sol / acc.n;
    const avgUsd = acc.usd / acc.n;
    return {
      top:    `${avgSol.toFixed(6)} SOL`,
      bottom: `$${avgUsd.toFixed(6)}`
    };
  }

  const pricePerOne = Number(meTrade.priceQuotePerBase ?? meTrade.price ?? 0);
  const amount      = Number(meTrade.baseAmount ?? meTrade.amount ?? 0);
  const quoteMint   = meTrade.quoteMint ?? '';
  const baseMint    = meTrade.baseMint  ?? '';

  if (!pricePerOne || !amount) {
    if (!acc.n) return { top: '', bottom: '' };
    const avgSol = acc.sol / acc.n;
    const avgUsd = acc.usd / acc.n;
    return {
      top:    `${avgSol.toFixed(6)} SOL`,
      bottom: `$${avgUsd.toFixed(6)}`
    };
  }

  let tradeSol = 0;
  let tradeUsd = 0;

  if (quoteMint === WSOL_MINT) {
    tradeSol = pricePerOne * amount;
    tradeUsd = solUsd ? tradeSol * solUsd : 0;
  } else if (quoteMint === USDC_MINT) {
    tradeUsd = pricePerOne * amount;
    tradeSol = solUsd ? tradeUsd / solUsd : 0;
  } else if (baseMint === WSOL_MINT) {
    tradeSol = amount;
    tradeUsd = solUsd ? tradeSol * solUsd : 0;
  } else {
    // fallback: считаем как $, при наличии solUsd переводим в SOL
    tradeUsd = pricePerOne * amount;
    if (solUsd) tradeSol = tradeUsd / solUsd;
  }

  // накапливаем сумму SELL по аналогии с Av
  acc.usd = (acc.usd || 0) + tradeUsd;
  acc.sol = (acc.sol || 0) + tradeSol;
  acc.n   = (acc.n   || 0) + 1;

  const avgSol = acc.sol / acc.n;
  const avgUsd = acc.usd / acc.n;

  return {
    top:    `${avgSol.toFixed(6)} SOL`,
    bottom: `$${avgUsd.toFixed(6)}`
  };
}



function formatPool(c, solUsd) {
  if (!c || typeof c.liquidityUsd !== 'number' || typeof c.priceUsd !== 'number' || c.priceUsd <= 0) return '';
  const half = c.liquidityUsd / 2;
  const baseQty = half / c.priceUsd;

  let quoteUsd = 1;
  const q = (c.quoteSymbol || '').toUpperCase();
  if (q === 'SOL' && typeof solUsd === 'number' && solUsd > 0) quoteUsd = solUsd;
  const quoteQty = half / quoteUsd;

  const bSym = (c.baseSymbol || (c.pair?.split('/')?.[0] ?? '')).toUpperCase();
  const qSym = (c.quoteSymbol || (c.pair?.split('/')?.[1] ?? '')).toUpperCase();

  const fmt = (x) => (x >= 1 ? Math.round(x).toLocaleString() : x.toFixed(4));
  return `${fmt(baseQty)} ${bSym} / ${fmt(quoteQty)} ${qSym}`;
}



useEffect(() => {
  if (!isAddOpen) {
    setDepositAddress(''); // сбрасываем адрес при закрытии окна
  }
}, [isAddOpen]);



  const modalOpen = isAddOpen || isWithdrawOpen || isSettingsEditOpen;
  const openAddFunds = async () => {
    if (!walletName) {
      alert('Ne vibran kosheljok');
      return;
    }
    try {
      const res = await fetch(`/api-auth/api/wallet/${encodeURIComponent(walletName)}`, {
        credentials: 'include',
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Ne udalosj polucitj adres koselka');
      setDepositAddress(data.address || '');
      setSolanaNetwork(walletData?.settings?.solanaNetwork || 'mainnet-beta');
      setIsAddOpen(true);
    } catch (e) {
      alert('Error: ' + (e.message || e));
    }
  };



  const handleStartBot = async () => {
    try {
      if (!walletName) { alert('Ne vibran kosheljok'); return; }
      const r = await fetch('/api-auth/start-bot', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ name: walletName })
      });
      const j = await r.json();
      if (!r.ok || j?.error) throw new Error(j?.error || ('HTTP ' + r.status)); 
      alert('Bot started');
    } catch (e) {
      alert('Oshibka start-bot: ' + (e.message || e));
    }
  };


  const handleStopBot = async () => {
    try {
      if (!walletName) { alert('Ne vibran kosheljok'); return; }
      const r = await fetch('/api-auth/stop-bot', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ name: walletName })
      });
      const j = await r.json();
      if (!r.ok || j?.error) throw new Error(j?.error || ('HTTP ' + r.status));
      alert ('Bot stopped');
    } catch (e) {
      alert('Oshibka stop-bot: ' + (e.message || e));
    }
  };


const tradePairs = React.useMemo(() => (
  Array.isArray(trades)
    ? trades.slice(-100).reverse().map(t => ({
        trader: t.trader || (!t.me ? t : null),
        me: t.me || null,
        time: t.time || t.timestamp || Date.now()
      }))
    : []
), [trades]);



  // --- Последние сделки строго по ТЕКУЩЕМУ токену, порознь: трейдер / мой бот
  const lastTraderTrade = pickLastTradeBy(trades, 'trader', currentMint);
  const lastMeTrade = pickLastTradeBy(trades, 'me', currentMint);

    // --- Последняя Buy сделка трейдера/ Me по текущему токену
  const lastTraderBuy = Array.isArray(trades)
  ? trades
      .filter(t =>
        !t.me &&
        normalizeMint(t.mint || t.baseMint || (Array.isArray(t.mints) ? t.mints[0] : '')) === normalizeMint(currentMint) &&
        String(t.side || '').toLowerCase() === 'buy'
      )
      .sort((a,b)=> (b.time||b.timestamp)-(a.time||a.timestamp))[0]
  : null;

  const lastMeBuy = Array.isArray(trades)
  ? trades
      .filter(t =>
        t.me &&
        normalizeMint(t.mint || t.baseMint || (Array.isArray(t.mints) ? t.mints[0] : '')) === normalizeMint(currentMint) &&
        String(t.side || '').toLowerCase() === 'buy'
      )
      .sort((a,b)=> (b.time||b.timestamp)-(a.time||a.timestamp))[0]
  : null;


        // --- Последняя SELL сделка трейдера/ Me по текущему токену
const lastTraderSell = Array.isArray(trades)
  ? trades
      .filter(t =>
        !t.me &&
        normalizeMint(
          t.mint || t.baseMint ||
          (Array.isArray(t.mints) ? t.mints[0] : '')
        ) === normalizeMint(currentMint) &&
        String(t.side).toLowerCase() === 'sell'
      )
      .sort((a,b)=> (b.time||b.timestamp)-(a.time||a.timestamp))[0]
  : null;

const lastMeSell = Array.isArray(trades)
  ? trades
      .filter(t =>
        t.me &&
        normalizeMint(
          t.mint || t.baseMint ||
          (Array.isArray(t.mints) ? t.mints[0] : '')
        ) === normalizeMint(currentMint) &&
        String(t.side).toLowerCase() === 'sell'
      )
      .sort((a,b)=> (b.time||b.timestamp)-(a.time||a.timestamp))[0]
  : null;

// Time elapsed (отдельно)
const lastElapsedTrader = lastTraderTrade
  ? formatElapsed((Date.now() - Number(lastTraderTrade.time || lastTraderTrade.timestamp || 0)) / 1000)
  : '';
const lastElapsedMe = lastMeTrade
  ? formatElapsed((Date.now() - Number(lastMeTrade.time || lastMeTrade.timestamp || 0)) / 1000)
  : '';

// Buy amount (последний объём базового токена — по соответствующей сделке)
const lastAmountTrader = lastTraderTrade && typeof (lastTraderTrade.baseAmount ?? lastTraderTrade.amount) === 'number'
  ? Number(lastTraderTrade.baseAmount ?? lastTraderTrade.amount)
  : null;
const lastAmountMe = lastMeTrade && typeof (lastMeTrade.baseAmount ?? lastMeTrade.amount) === 'number'
  ? Number(lastMeTrade.baseAmount ?? lastMeTrade.amount)
  : null;

  // Open price (отдельно)
  const lastTraderPriced = toUsdPrice(lastTraderTrade);
  const lastMePriced     = toUsdPrice(lastMeTrade);

  const openTrader = lastTraderBuy ? formatOpenPriceForTrader(lastTraderBuy, solUsd) : { top:'', bottom:'' }; 
  const openWallet = lastMeBuy ? formatOpenPriceForMe(lastMeBuy, solUsd) : { top:'', bottom:'' };

  // --- Цена за 1 токен (Price per token) ---
  const perTokenTraderFmt = formatPricePerToken(lastTraderPriced, solUsd);
  const perTokenMeFmt     = formatPricePerToken(lastMePriced, solUsd);


  const lastAny = getLastBasicTrade(trades);
  const lastAmount = lastAny && typeof (lastAny.baseAmount ?? lastAny.amount) === 'number'
    ? Number(lastAny.baseAmount ?? lastAny.amount)
    : null;

  const avgBuyTraderFmt = avgTraderLive ?? { top: '', bottom: '' };
  const avgBuyMeFmt = avBuyMeLive ?? { top: '', bottom: '' };

  const closedTraderFmt = lastTraderSell
  ? { top: `${lastTraderSell.quoteAmount.toFixed(6)} SOL`, bottom: solUsd ? `$${(lastTraderSell.quoteAmount * solUsd).toFixed(6)}` : '' }
  : { top:'', bottom:'' };
  const closedMeFmt = lastMeSell
  ? { top: `${lastMeSell.quoteAmount.toFixed(6)} SOL`, bottom: solUsd ? `$${(lastMeSell.quoteAmount * solUsd).toFixed(6)}` : '' }
  : { top:'', bottom:'' };

  const lastElapsed = lastAny
    ? formatElapsed((Date.now() - Number(lastAny.time || lastAny.timestamp || 0)) / 1000)
    : '';
  const tr  = pnlSrv.trader || {};
  const mep = pnlSrv.me || {};

  const realisedColorTrader   = Number.isFinite(tr.realised)   ? (tr.realised   > 0 ? 'green' : tr.realised   < 0 ? 'red' : '') : '';
  const unrealisedColorTrader = Number.isFinite(tr.unrealised) ? (tr.unrealised > 0 ? 'green' : tr.unrealised < 0 ? 'red' : '') : '';
  const roiStr        = Number.isFinite(tr.roiPct)  ? `${tr.roiPct.toFixed(2)} %` : '';
  const roiColorTrader= Number.isFinite(tr.roiPct)  ? (tr.roiPct > 0 ? 'green' : tr.roiPct < 0 ? 'red' : '') : '';

  const realisedColorMe   = Number.isFinite(mep.realised)   ? (mep.realised   > 0 ? 'green' : mep.realised   < 0 ? 'red' : '') : '';
  const unrealisedColorMe = Number.isFinite(mep.unrealised) ? (mep.unrealised > 0 ? 'green' : mep.unrealised < 0 ? 'red' : '') : '';
  const roiMeStr     = Number.isFinite(mep.roiPct) ? `${mep.roiPct.toFixed(2)} %` : '';
  const roiColorMe   = Number.isFinite(mep.roiPct) ? (mep.roiPct > 0 ? 'green' : mep.roiPct < 0 ? 'red' : '') : '';

  const rowsToShow = pendingExpanded ? 8 : 2;



  return (
    <div style={{
      backgroundColor: '#1e1e1e',
      color: 'white',
      minHeight: '100vh',
      padding: '40px',
      fontFamily: 'sans-serif',
    }}>



        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}>
          <label style={{ marginRight: 8, color: '#d1d5db' }}>Wallet:</label>
          <select
            value={walletName || ''}
            onChange={(e) => {
              const name = e.target.value;
              if (name) navigate(`/trading/${name}`);
            }}
            style={{
              backgroundColor: '#111827',
              color: '#d1d5db',
              border: '1px solid #333',
              borderRadius: 6,
              padding: '6px 10px',
              minWidth: 220
            }}
          >
            <option value="" disabled>
              {walletsList.length ? 'Select wallet' : 'No wallets'}
            </option>
            {walletsList.map((name) => (
              <option key={name} value={name}>{name}</option>
          ))}
        </select>

      <h1 style={{ fontSize: '2rem', margin: 0, textAlign: 'center', display: 'flex', alignItems: 'center', gap: 12, justifyContent: 'center' }}>
        Trading: {walletName}
          <span
            style={{ padding: '4px 10px', borderRadius: 12, fontSize: 14, fontWeight: 600, }}>
            </span>
      </h1>

      <div style={{ marginLeft: 'auto', display: 'flex', gap: 8, paddingRight: 20 }}>
        <button
          style={{
            backgroundColor: '#22c55e',
            color: '#000',
            padding: '6px 12px',
            border: 'none',
            borderRadius: '4px',
            fontWeight: 600,
            cursor: 'pointer',
            marginRight: 8
          }}
          onClick={openAddFunds}
        >
          Add Funds
        </button>



        <button
          style={{
          backgroundColor: '#22c55e',
          color: '#000',
          padding: '6px 12px',
          border: 'none',
          borderRadius: '4px',
          fontWeight: 600,
          cursor: 'pointer'
        }}
        onClick={() => setIsWithdrawOpen(true)}
      >
        Withdraw SOL
      </button>
    </div>
  </div>


      <div style={{ display: 'flex',alignItems: 'center', marginTop: 8, marginBottom: 16 }}>
        <button
          style={{
            backgroundColor: '#22c55e',
            color: '#000',
            padding: '6px 12px',
            border: 'none',
            borderRadius: '4px',
            fontWeight: 600,
            cursor: 'pointer'
          }}
          onClick={() => setIsSettingsEditOpen(true)}
        >
          Settings
        </button>

      <div style={{ marginLeft: 'auto', display: 'flex', gap: 8 }}>

        <button
          style={{
          backgroundColor: '#22c55e',
          color: '#000',
          padding: '6px 12px',
          border: 'none',
          borderRadius: '4px',
          fontWeight: 600,
          cursor: 'pointer'
        }}
        onPointerDown={() => {
          const a = new Audio('/click.mp3');
          a.volume = 1; 
          a.currentTime = 0;
          a.play();
          handleStartBot();
        }}
      >
        Start Bot
      </button>

      <button
        style={{
          backgroundColor: '#ef4444',
          color: '#000',
          padding: '6px 12px',
          border: 'none',
          borderRadius: '4px',
          fontWeight: 600,
          cursor: 'pointer'
        }}
        onPointerDown={() => {
          const a = new Audio('/click.mp3');
          a.volume = 1;
          a.currentTime = 0;
          a.play();
          handleStopBot();
        }}
      >
        Stop Bot
      </button>
    </div>
  </div>



  <div style={{
    display:'flex', alignItems:'center', gap:12, 
    margin:'8px auto 16px', maxWidth:1100,
    padding:'8px 12px', border:'1px solid #333', borderRadius:8, background:'#151515'
}}>
  <div style={{color:'#d1d5db'}}>
    <b>Stream:</b> <span style={{color: streamActive ? '#22c55e' : '#ef4444'}}>
      {streamActive ? 'Активен' : 'Неактивен'}
    </span>
    &nbsp; | &nbsp;
    <b>Active RPC:</b> {activeRpc || '—'} 
  </div>

  <div style={{marginLeft:'auto', display:'flex', gap:8}}>
    <button
      onClick={() => {
        if (typeof refreshRpc === 'function') {
          refreshRpc();
          alert('Обновлено');
        } else {
          alert('RPC refresh недоступен');
        }
      }}
      style={{background:'#374151', color:'#d1d5db', border:'1px solid #4b5563', borderRadius:6, padding:'6px 10px', cursor:'pointer'}}
    >
      Обновить
    </button>

    <button
      onClick={async () => {
        try {
          if (!walletName) { alert('Не выбран кошелёк'); return; }
          await fetch('/api-auth/stop-bot', {
            method:'POST', headers:{'Content-Type':'application/json'},
            credentials:'include', body: JSON.stringify({ name: walletName })
          });
          const r = await fetch('/api-auth/start-bot', {
            method:'POST', headers:{'Content-Type':'application/json'},
            credentials:'include', body: JSON.stringify({ name: walletName })
          });
          const j = await r.json();
          if (!r.ok || j?.error) throw new Error(j?.error || ('HTTP '+r.status));
          alert('Подписки пересозданы');
        } catch (e) {
          alert('Ошибка переключения: ' + (e.message || e));
        }
      }}
      style={{background:'#2563eb', color:'#fff', border:'none', borderRadius:6, padding:'6px 10px', cursor:'pointer'}}
    >
      Переключение
    </button>
  </div>
</div>


    {/* Trading table*/}
    <div style={{ display: 'block' , margin: '24px auto', width: '100%', maxWidth: 1100, maxHeight: 420, overflowY: 'auto' }}>
      <table border="1" cellPadding="10" cellSpacing="0" style={{ borderColor: '#333', borderCollapse: 'collapse', width: '100%', maxWidth: 1100, }}>
        <thead>
          <tr style={{ backgroundColor: '#2c2c2c', borderBottom: '1px solid #333', color: '#d1d5db' }}>
            <th>My wallet ,traderAddress</th>
            <th>Coin</th>
            <th>Balance</th>
            <th>Buy amount</th>
            <th>Time elapsed</th>
            <th>Price per token</th>
            <th>Open price</th>
            <th>Av Buy price</th>
            <th>Closed Price</th>
            <th>Realised PNL</th>
            <th>Unrealised PNL</th>
            <th>Total PNL</th>
            <th>ROI</th>
          </tr>
        </thead>
        <tbody >
              <tr style={{ color: '#ccc' }}>
                <td title={traderAddress || ''}>{traderAddress ? shortenAddress(traderAddress) : 'Copy trader'}<br /></td>
                <td title={pairLabel || ''}>{coinText}</td>
                <td>{traderSol !== null ? `${traderSol.toFixed(4)} SOL` : ''}<br />{typeof solUsd === 'number' && traderSol !== null ? `$${(traderSol * solUsd).toFixed(2)}` : ''}</td>
                <td>{buyAmountTraderLive != null ? buyAmountTraderLive.toFixed(8) : ''}</td>    {/* Buy amount */}
                <td>{lastElapsedLive}</td>           {/* Time elapsed */}
                <td>{(perTokenTraderLive.top || perTokenTraderFmt.top)}<br />{(perTokenTraderLive.bottom || perTokenTraderFmt.bottom)}</td>
                <td>{(openTraderLive?.top || openTrader.top)}<br />{(openTraderLive?.bottom || openTrader.bottom)}</td>  {/* Open price — СЮДА */}
                <td>{(avgTraderLive?.top || avgBuyTraderFmt.top)}<br />{(avgTraderLive?.bottom || avgBuyTraderFmt.bottom)}</td>      {/* Av Buy price */}
                <td>{(closedTraderLive?.top || closedTraderFmt.top)}<br />{(closedTraderLive?.bottom || closedTraderFmt.bottom)}</td>      {/* Closed Price */}
                <td style={{ color: realisedColorTrader }}>{Number.isFinite(tr?.realisedUsd) ? `$${tr.realisedUsd.toFixed(6)}` : ''}</td>         {/* Realised PNL */}
                <td style={{ color: unrealisedColorTrader }}>{Number.isFinite(tr?.unrealisedUsd) ? `$${tr.unrealisedUsd.toFixed(6)}` : ''}</td>        {/* Unrealised PNL */}
                <td>{Number.isFinite(tr?.totalUsd) ? `$${tr.totalUsd.toFixed(2)}` : ''}</td>             {/* Total PNL */}
                <td style={{ color: roiColorTrader }}>{Number.isFinite(tr?.roiPct) ? `${tr.roiPct.toFixed(2)} %` : ''}</td>              {/* ROI */}
              </tr>

              <tr style={{ color: '#ccc', backgroundColor: '#1f1f1f' }}>
                <td>{walletName || '-'}</td>
                <td title={pairLabel || ''}>{coinText}</td> 
                <td>{mySol !== null ? `${mySol.toFixed(4)} SOL` : ''}<br />{typeof solUsd === 'number' && mySol !== null ? `$${(mySol * solUsd).toFixed(2)}` : ''}</td>
                <td>{buyAmountMeLive != null ? buyAmountMeLive.toFixed(6) : (lastAmountMe != null ? lastAmountMe.toFixed(6) : '')}</td>   {/* Buy amount */}
                <td>{lastElapsedMe}</td>              {/* Time elapsed */}
                <td>{(perTokenMeLive?.top || perTokenMeFmt.top)}<br />{(perTokenMeLive?.bottom || perTokenMeFmt.bottom)}</td>
                <td>{(openWalletLive?.top || openWallet.top)}<br />{(openWalletLive?.bottom || openWallet.bottom)}</td>  {/* Open price — СЮДА */}
                <td>{(avBuyMeLive?.top || avgBuyMeFmt.top)}<br />{(avBuyMeLive?.bottom || avgBuyMeFmt.bottom)}</td>    {/* Av Buy price */}
                <td>{(closedMeLive?.top || closedMeFmt.top)}<br />{(closedMeLive?.bottom || closedMeFmt.bottom)}</td>    {/* Closed Price */}
                <td style={{ color: realisedColorMe }}>{Number.isFinite(mep?.realisedUsd) ? `$${mep.realisedUsd.toFixed(6)}` : ''}</td>       {/* Realised PNL */}
                <td style={{ color: unrealisedColorMe }}>{Number.isFinite(mep?.unrealisedUsd) ? `$${mep.unrealisedUsd.toFixed(6)}` : ''}</td>     {/* Unrealised PNL */}
                <td>{Number.isFinite(mep?.totalUsd) ? `$${mep.totalUsd.toFixed(2)}` : ''}</td>         {/* Total PNL */}
                <td style={{ color: roiColorMe }}>{Number.isFinite(mep?.roiPct) ? `${mep.roiPct.toFixed(2)} %` : ''}</td>            {/* ROI */}
              </tr>
            </tbody>
          </table>
        </div>


  {/* LAST TRADES TOGGLE */}
  <div style={{width:'100%',maxWidth:800,margin:'12px auto',position:'relative'}}>
  <div onClick={()=>setTradesOpen(o=>!o)} style={{height:28,lineHeight:'28px',padding:'0 8px',border:'1px solid #333',cursor:'pointer',color:'#3b82f6'}}>
    Last trades {tradesOpen?'▲':'▼'}
  </div>
  {tradesOpen && (
  <div style={{position:'absolute',top:30,left:0,width:'100%',maxHeight:180,overflowY:'auto',background:'#111',border:'1px solid #333',zIndex:1000,fontSize:12}}>
    {tradePairs.slice(0,100).map((p,i)=> {
  const trader = p.trader;
  const me = p.me;

  const row = (who, t) => {
    if (!t) {
      return (
        <div key={who} style={{ padding:'8px 12px', color:'#555' }}>
          {who} | —
        </div>
      );
    }

    const side   = String(t.side || '').toUpperCase();
    const sideColor = side === 'BUY' ? '#22c55e' : side === 'SELL' ? '#ef4444' : '#ccc';
    const symbol = (t.baseSymbol || t.symbol || '').trim() || (t.baseMint || t.mint || '');
    const amount = Number(t.baseAmount ?? t.amount ?? 0);
    const pricePerTokenUsd = Number.isFinite(t.priceQuotePerBase) ? (t.quoteMint === WSOL_MINT && Number.isFinite(solUsd) ? t.priceQuotePerBase * solUsd : t.priceQuotePerBase) : null;
    const sumUsd = Number.isFinite(t.quoteAmount) ? ((t.quoteMint === WSOL_MINT ? t.quoteAmount * solUsd : t.quoteAmount).toFixed(2)) : '—';
    const ts     = new Date((p.time>1e12?p.time:p.time*1000)).toLocaleTimeString().slice(0,5);

    return (
      <div key={who} style={{ padding:'8px 12px', textAlign: 'justify' ,textAlignLast: 'justify' }}>
        {ts} | {who} | <span style={{ color: sideColor }}>{side}</span> | {symbol} | {amount.toLocaleString()} @ @ ${pricePerTokenUsd != null ? pricePerTokenUsd.toFixed(8) : '—'} = ${sumUsd}
      </div>
    );
  };

  return (
    <div key={i} style={{ borderBottom:'1px solid #222' }}>
      {row('Trader', trader)}
      {row('Me', me)}
    </div>
  );
})}
  </div>
)}
</div>



     {/* POKUPKA ORDEROV */}
<h3 style={{ color: '#d1d5db', margin: '16px auto 8px', maxWidth: 1100 }}>
  Manual Buy Orders
</h3>
<div style={{ display: 'block', margin: '24px auto', width: '100%', maxWidth: 1100, maxHeight: 220, overflowY: 'auto' }}>
  <table border="1" cellPadding="4" cellSpacing="0" style={{ borderColor: '#333', borderCollapse: 'collapse', width: '100%', maxWidth: 1100, backgroundColor: '#1e1e1e' }}>
    <thead>
      <tr style={{ backgroundColor: '#2c2c2c', borderBottom: '1px solid #333', color: '#d1d5db' }}>
        <th>Mint</th>
        <th>Buy Price ($)</th>
        <th>Buy Sum (SOL)</th>
        <th>TP (%)</th>
        <th>TP Price ($)</th>
        <th>Coin</th>
        <th>Bought Amount</th>
        <th>Status</th>
        <th>Start / Stop</th>
        <th>Del</th>
      </tr>
    </thead>
    <tbody style={{ color: '#ccc', lineHeight: '1.8' }}>
      {Array.from({ length: Math.max(5, (manualBuyOrders?.length || 0) + 1) }).map((_, i) => (
        <tr key={i}>
          <td>
            <input
              name={`manual-buy-mint-${i}`}
              id={`manual-buy-mint-${i}`}
              value={manualBuyInputs[i]?.mint ?? manualBuyOrders[i]?.mint ?? ''}
              onChange={e => setManualBuyInputs(prev => ({ ...prev, [i]: { ...(prev[i] || {}), mint: e.target.value } }))}
              style={{ width: '260px', background: '#1e1e1e', color: '#fff', border: '1px solid #444' }}
            />
          </td>
          <td>
            <input
              name={`manual-buy-price-${i}`}
              id={`manual-buy-price-${i}`}
              value={manualBuyInputs[i]?.buyPriceUsd ?? manualBuyOrders[i]?.buyPriceUsd ?? ''}
              onChange={e => setManualBuyInputs(prev => ({ ...prev, [i]: { ...(prev[i] || {}), buyPriceUsd: e.target.value } }))}
              style={{ width: '90px', background: '#1e1e1e', color: '#fff', border: '1px solid #444' }}
            />
          </td>
          <td>
            <input
              name={`manual-buy-sum-${i}`}
              id={`manual-buy-sum-${i}`}
              value={manualBuyInputs[i]?.buySumSol ?? manualBuyOrders[i]?.buySumSol ?? ''}
              onChange={e => setManualBuyInputs(prev => ({ ...prev, [i]: { ...(prev[i] || {}), buySumSol: e.target.value } }))}
              style={{ width: '90px', background: '#1e1e1e', color: '#fff', border: '1px solid #444' }}
            />
          </td>
          <td>
            <input
              name={`manual-buy-tp-pct-${i}`}
              id={`manual-buy-tp-pct-${i}`}
              value={manualBuyInputs[i]?.targetProfitPct ?? manualBuyOrders[i]?.targetProfitPct ?? ''}
              onChange={e => setManualBuyInputs(prev => ({ ...prev, [i]: { ...(prev[i] || {}), targetProfitPct: e.target.value } }))}
              style={{ width: '60px', background: '#1e1e1e', color: '#fff', border: '1px solid #444' }}
            />
          </td>
          <td>
            <input
              name={`manual-buy-tp-price-${i}`}
              id={`manual-buy-tp-price-${i}`}
               value={manualBuyInputs[i]?.targetPriceUsd ?? manualBuyOrders[i]?.targetPriceUsd ?? ''}
               onChange={e => setManualBuyInputs(prev => ({ ...prev, [i]: { ...(prev[i] || {}), targetPriceUsd: e.target.value } }))}
              style={{ width: '90px', background: '#1e1e1e', color: '#fff', border: '1px solid #444' }}
            />
          </td>
          <td>{manualBuyOrders[i]?.symbol || ''}</td>
          <td>{manualBuyOrders[i]?.boughtAmount || ''}</td>
          <td style={{ color: manualBuyOrders[i]?.running ? '#22c55e' : (pending.some(p => Number(p?.manualRowIndex) === i) ? '#facc15' : '#ef4444'), fontWeight: 600 }}>
            {manualBuyOrders[i]?.running ? 'On' : (pending.some(p => Number(p?.manualRowIndex) === i) ? 'Pen' : 'Off')}</td>

          <td>
            <button 
              style={{ background: 'none', border: `1px solid ${manualBuyOrders[i]?.running ? '#ef4444' : '#3b82f6'}`, color: manualBuyOrders[i]?.running ? '#ef4444' : '#3b82f6', padding: '2px 10px', cursor: 'pointer' }}
              onClick={async () => {
                const mint = manualBuyInputs[i]?.mint ?? manualBuyOrders[i]?.mint ?? '';
                const buyPriceUsd = manualBuyInputs[i]?.buyPriceUsd ?? manualBuyOrders[i]?.buyPriceUsd ?? '';
                const buySumSol = manualBuyInputs[i]?.buySumSol ?? manualBuyOrders[i]?.buySumSol ?? '';
                const targetProfitPct = manualBuyInputs[i]?.targetProfitPct ?? manualBuyOrders[i]?.targetProfitPct ?? '';
                const targetPriceUsd = manualBuyInputs[i]?.targetPriceUsd ?? manualBuyOrders[i]?.targetPriceUsd ?? '';
                await saveManualBuyOrder(walletName, i, mint, buyPriceUsd, buySumSol, targetProfitPct, targetPriceUsd, manualBuyOrders[i]?.symbol || '', !manualBuyOrders[i]?.running);
                await loadManualBuyOrders(walletName);
              }}
            >
              {manualBuyOrders[i]?.running ? 'Stop' : 'Start'}
            </button>
          </td>
          <td>
            <button
              style={{ background: 'none', border: '1px solid #ef4444', color: '#ef4444', padding: '2px 10px', cursor: 'pointer' }}
              onClick={async () => {
                 await deleteManualBuyOrder(walletName, i);
                 setManualBuyInputs(prev => {
                   const next = { ...prev };
                   delete next[i];
                   return next;
                 });
                 await loadManualBuyOrders(walletName);
              }}
            >
              Del
            </button>
          </td>
        </tr>
      ))}
    </tbody>
  </table>
</div>


    {/* Pending */}

<h3 style={{ color: '#d1d5db', margin: '16px auto 8px', maxWidth: 1100 }}>Pending – Hvosti</h3>
<div style={{ display: 'block', margin: '24px auto', width: '100%', maxWidth: 1100, maxHeight: 220, overflowY: 'auto' }}>
  <table
    border="1"
    cellPadding="4"
    cellSpacing="0"
    style={{ borderColor: '#333', borderCollapse: 'collapse', width: '100%', maxWidth: 1100, backgroundColor: '#1e1e1e' }}
  >
    <thead>
      <tr style={{ backgroundColor: '#2c2c2c', borderBottom: '1px solid #333', color: '#d1d5db' }}>
        <th>Coin</th>
        <th>Amount</th>
        <th>Last Buy ($)</th>
        <th>Current Price ($)</th>
        <th> Current P (%)</th>
        <th>TP (%)</th>
        <th>TP Price ($)</th>
        <th>Price On ($)</th>
        <th>Sell</th>
        <th style={{ textAlign: 'center' }}>
        <button
          style={{
            background: 'none',
            border: 'none',
            color: '#3b82f6',
            cursor: 'pointer',
            fontSize: '14px'
          }}
          onClick={() => setPendingExpanded(prev => !prev)}
        >
          {pendingExpanded ? '▲ ' : '▼ '}
          {pending.length > 0 && ` ${pending.length}`}
        </button>
      </th>
      </tr>
    </thead>
    <tbody style={{ color: '#ccc', lineHeight: '1.8' }}>
      {Array.from({ length: pending.length }).map((_, i) => (
      <tr key={i}>
        <td>{pending[i]?.symbol || ''}</td>
        <td>{pending[i]?.amount ?? ''}</td>
        <td>{pending[i]?.lastBuyPriceUsd != null ? `$${pending[i].lastBuyPriceUsd}` : ''}</td>
        <td>{pending[i]?.currentPriceUsd != null ? `$${pending[i].currentPriceUsd}` : ''}</td>
        <td style={{ color: pending[i]?.lastBuyPriceUsd != null && pending[i]?.currentPriceUsd != null ? (pending[i].currentPriceUsd > pending[i].lastBuyPriceUsd ? '#22c55e' : pending[i].currentPriceUsd < pending[i].lastBuyPriceUsd ? '#ef4444' : '#ccc') : '#ccc' }}>
          {pending[i]?.lastBuyPriceUsd != null && pending[i]?.currentPriceUsd != null 
            ? `${pending[i].currentPriceUsd > pending[i].lastBuyPriceUsd ? '+' : pending[i].currentPriceUsd < pending[i].lastBuyPriceUsd ? '-' : ''}${Math.abs(((pending[i].currentPriceUsd - pending[i].lastBuyPriceUsd) / pending[i].lastBuyPriceUsd) * 100).toFixed(2)}%` : ''}</td>
        <td>{pending[i]?.targetProfitPct != null ? `${pending[i].targetProfitPct}%` : ''}</td>
        <td>{pending[i]?.targetPriceUsd != null ? pending[i].targetPriceUsd : ''}</td>
        <td>
          <input
            name={`pending-price-${i}`}
            id={`pending-price-${i}`}
            style={{
              width: '90px',
              background: '#1e1e1e',
              color: '#fff',
              border: '1px solid #444'
            }}
            value={priceInputs[i] || ''}
            onChange={e =>
              setPriceInputs(prev => ({ ...prev, [i]: e.target.value }))
            }
          />
        </td>
        <td>
          <button
            style={{
              background: 'none',
              border: '1px solid #3b82f6',
              color: '#3b82f6',
              padding: '2px 6px',
              cursor: 'pointer'
            }}
            onClick={() => {
              const v = inputs[i], price = document.getElementById(`pending-price-${i}`)?.value || '';
              if (!v && !price) {
                sendPendingSell(walletName, pending[i]?.mint, pending[i]?.amount)
                  .then(() => {
                    setPending(prev => prev.filter((_, idx) => idx !== i));
                  })
                  .catch(() => {});
                return;
              }
              setTargets(prev => ({ ...prev, [i]: v }));   // записываем Target Profit
              setInputs(prev => ({ ...prev, [i]: '' }));   // очищаем input
              setPriceInputs(prev => ({ ...prev, [i]: '' }));
              sendTargetProfit(walletName, pending[i]?.mint, v, price);
            }}
          >
            Sell
          </button>
        </td>

        {/* 9-я колонка — ввод процента */}
        <td>
          <input
            name={`pending-profit-${i}`}
            id={`pending-profit-${i}`}
            style={{
              width: '45px',
              background: '#1e1e1e',
              color: '#fff',
              border: '1px solid #444'
            }}
            value={inputs[i] || ''}
            onChange={e =>
              setInputs(prev => ({ ...prev, [i]: e.target.value }))
            }
          />
        </td>
      </tr>
    ))}
    </tbody>
  </table>
</div>



<div style={{ marginBottom: 10 }}>
  {!graphEnabled ? (
    <button onClick={() => setGraphEnabled(true)}>
      ▶ Start Graph
    </button>
  ) : (
    <button onClick={() => setGraphEnabled(false)}>
      ⏹ Stop Graph
    </button>
  )}
</div>

   {/* Real time chart placeholder */}
    <div style={{ margin: '16px auto', width: '100%', maxWidth: 1100, padding: 12, border: '1px solid #333', borderRadius: 8, pointerEvents: 'auto' }}>
      <h3 style={{ margin: 0, marginBottom: 8, color: '#d1d5db' }}>Trading chart</h3>
      {graphEnabled && (
        <TradeChart candles={mergedCandles} markers={chartMarkers} height={360} />
      )}
    <div style={{marginTop:8, color:'#9ca3af'}}>mint: {currentMint || '--'} candles: {Array.isArray(candles) ? candles.length : 0} markers: {Array.isArray(chartMarkers) ? chartMarkers.length : 0}</div>
    </div>


    {/* Black list */}
    <h3 style={{ color: '#d1d5db', margin: '16px auto 8px', maxWidth: 1100 }}>Blacklist</h3>
    <div style={{ margin: '16px auto', width: '100%', maxWidth: 1100, maxHeight: '260px', overflowY: 'auto' }}>
      <table border="1" cellPadding="10" cellSpacing="0" style={{ borderColor: '#333', borderCollapse: 'collapse', width: '100%' }}>
        <thead>
          <tr style={{ backgroundColor: '#2c2c2c', borderBottom: '1px solid #333', color: '#d1d5db' }}>
            <th>Coin</th>
            <th>Mint</th>
            <th>Wallet</th>
            <th>Amount</th>
            <th>Buy Sum</th>
            <th>Reason</th>
            <th>Time</th>
            <th>Tx</th>
          </tr>
        </thead>
        <tbody>
          {[...Array(5)].map((_, i) => {
          const row = blacklist[i];
          return (
          <tr key={i} style={{ color: '#ccc', lineHeight: '1.8' }}>
            <td>{row?.coin || ''}</td>
            <td>{row?.mint || ''}</td>
            <td>{row?.wallet || ''}</td>
            <td>{row?.amount || ''}</td>
            <td>{row?.buySum || ''}</td>
            <td>{row?.reason || ''}</td>
            <td>{row ? new Date(row.time).toLocaleString() : ''}</td>
            <td>{row?.tx ? <a href={`https://solscan.io/tx/${row.tx}`} target="_blank">tx</a> : ''}</td>
          </tr>
        );
        })}
      </tbody>
    </table>
  </div>

  {loading && <p>zagruzka...</p>}
  {error && null}
  {walletData && (
    <pre style={{ backgroundColor: '#2c2c2c', padding: '20px', borderRadius: '8px' }}>
      {JSON.stringify(walletData, null, 2)}
    </pre>
  )}


      {/* Modalka Add Funds */}
      <AddFundsModal
        isOpen={isAddOpen}
        onClose={() => setIsAddOpen(false)}
        walletAddress={depositAddress}
        solanaNetwork={solanaNetwork}
      />

      {/* Modalka Withdraw */}
      <WithdrawModal
        isOpen={isWithdrawOpen}
        onClose={() => setIsWithdrawOpen(false)}
        fromWalletName={walletName}
        fromAddress={depositAddress}
        solanaNetwork={solanaNetwork}
      />

      {/* Modalka Settings */}
      <SettingsModal
        isOpen={isSettingsEditOpen}
        onClose={() => setIsSettingsEditOpen(false)}
        activeWalletName={walletName}
      />
    </div>
  );
}



export default TradingPage;
